// export default {
//   apiBaseURLSocket: "http://192.168.33.79:3111",
//   mrdRecipt: 'http://192.168.33.79:3111/',
//   apiBaseURL: "http://192.168.33.79:3111/api",
//   frontEndURL: "http://192.168.33.79:3111"
// }
export default {
  apiBaseURLSocket: "https://stg-verifacto.amable.in",
  mrdRecipt: 'https://stg-verifacto.amable.in/',
  apiBaseURL: "https://stg-verifacto.amable.in/api" ,
  frontEndURL: "https://stg-verifacto.amable.in"
}
//  export default {
//    apiBaseURLSocket: "https://verifacto.amable.in",
//    mrdRecipt: 'https://verifacto.amable.in/',
//    apiBaseURL: "https://verifacto.amable.in/api" ,
//   frontEndURL: "https://verifacto.amable.in"
//  } 

// export default {
//   apiBaseURLSocket: "https://amableclaimprobe.com",
//   mrdRecipt: 'https://amableclaimprobe.com/',
//   apiBaseURL: "https://amableclaimprobe.com/api",
//   frontEndURL: "https://amableclaimprobe.com"
// }
